export default function createInterruptLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `interrupt:${input.type}` });
    return {
        created(details) {
            return log({
                type: "created",
                details,
            });
        },
        updated(details) {
            return log({
                type: "updated",
                details,
            });
        },
        deleted(interrupt, newState) {
            return log({
                type: "deleted",
                details: { interrupt, newState },
            });
        },
    };
}
